@if (visible()) {
  <div>
    <nz-row [id]="table.tableCode" [nzGutter]="[16, 16]">
      @for (record of visibleRecords(); track record.recordId) {
        <nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="8" nzXl="8" nzXXl="6">
          <div class="cards-container">
            <div class="downloadCard">
              @if (record?.recordData?.insuranceMandatory) {
                <div class="badge badge-required">Obligatorio</div>
              } @else {
                <div class="badge badge-optional">Opcional</div>
              }
              <div class="title">{{ record?.recordData?.insuranceType }}</div>
              <div class="subtitle">{{ record?.recordData?.insuranceRate ?? '' }}</div>
              <div class="subtitle">{{ record?.recordData?.insuranceCalculationBase ?? '' }}</div>
              <div>
                @if (!record?.recordData?.insuranceMandatory) {
                  <app-table-custom-action
                    [action]="insuranceActions.toggle"
                    [recordData]="record.recordData"
                    [recordId]="record.recordId"
                    (actionSelected)="tableActionSelected($event)"
                  >
                    <nz-switch
                      [nzCheckedChildren]="checkedTemplate"
                      [nzUnCheckedChildren]="unCheckedTemplate"
                      [ngModel]="record?.recordData?.insuranceSelected"
                    />
                  </app-table-custom-action>
                } @else {
                  <nz-switch
                    [nzCheckedChildren]="checkedTemplate"
                    [nzUnCheckedChildren]="unCheckedTemplate"
                    [ngModel]="record?.recordData?.insuranceSelected"
                    [nzDisabled]="record?.recordData?.insuranceMandatory"
                  />
                }
                <ng-template #checkedTemplate><nz-icon nzType="check" /></ng-template>
                <ng-template #unCheckedTemplate><nz-icon nzType="close" /></ng-template>
              </div>
            </div>
          </div>
        </nz-col>
      }
    </nz-row>
  </div>
}
